/**
 * Creates a JSON in AWS S3 repx output bucket
 * to be executed for the RepX algorithm.
 * It must have parameters and code snippet.
 */

export async function CreateRepXExecuteJSON(S3, codeSnippet, parameters) {
  const data = JSON.parse(localStorage.getItem("UpdatedDataArray")) || [];
  let selectedSnapshot = localStorage.getItem("selectedSnapshot");
  let bucketSource = process.env.REACT_APP_S3_REPX_SOURCE;
  let bucketOutput = process.env.REACT_APP_S3_REPX_OUTPUT;
console.log("codeSnippet2: ",codeSnippet);
console.log("params2", parameters);

  const jsonData = {
    task: codeSnippet,
    data_loc: data.find(item => item.Property === "data_loc")["Value (per property)"] || "",
    topics: data.find(item => item.Property === "topics")["Value (per property)"] || "",
    database: data.find(item => item.Property === "database")["Value (per property)"] || "",
    snapshot_location: data.find(item => item.Property === "snapshot_location")["Value (per property)"] || "",
    snapshot_name: data.find(item => item.Property === "snapshot_name")["Value (per property)"] || "",
    param: parameters
  };

  const jsonString = JSON.stringify(jsonData, null, 2); //Formatted JSON with 2-space identation
  const timestamp = Date.now();

  try {
    //Create the file in the source repx bucket
   await S3.putObject({ 
      Bucket: bucketSource, 
    Key: `${selectedSnapshot}_execute_${timestamp}.json`, 
    Body: jsonString,
    ContentType: 'application/json'
    }).promise();

    //Create the directory with the same name as the snapshot in the repx output bucket
    await S3.putObject({ 
      Bucket: bucketOutput, 
    Key: `${selectedSnapshot}`, 
    Body: jsonString,
    ContentType: 'application/json'
    }).promise();
  } catch (error) {
    console.log("error: ", error);
    throw new Error(error.message);
  }
 
}
